import { RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectRouter = createFeatureSelector<RouterReducerState>('router');

export const selectCurrentRoute = createSelector(
  selectRouter,
  (routerState) => routerState?.state
);

export const selectFirstChildRoute = createSelector(
    selectCurrentRoute,
    (route) => {
        if (route?.url) {
            const segments = route.url.split('/').filter(Boolean); // Split by '/' and remove empty strings
            return segments.length > 0 ? `/${segments[0]}` : '/';
        }
        return '/';
    }
);